import React from "react";
import SectionContainer from "./SectionContainer";

// const specialsData = [
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   { title: "Special One", description: "Description here.", url: "/#" },
//   { title: "Special Two", description: "Description here.", url: "/#" },
//   // More items
// ];

const Furniture = () => {
  return (
    <div>
      <SectionContainer
        title=""
        data={specialsData}
        gridClasses="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
      />
      {/* You can add more SectionContainer components with different data and titles */}
    </div>
  );
};

export default Furniture;
